// extracted by mini-css-extract-plugin
module.exports = {"title":"Burn_title__2dLGC","text":"Burn_text__rk-ud","info":"Burn_info__3Q785","input":"Burn_input__1Qq5N","btns":"Burn_btns__2dq76","button":"Burn_button__155i5"};